import { useLocalStorage } from 'hooks/useLocalStorage';
import { I18NEXT_LOCAL_STORAGE_NAME } from 'i18n/i18n';

export const getCurrentLng = (): string => {
  const { getLocalStorageItem } = useLocalStorage();

  return getLocalStorageItem(I18NEXT_LOCAL_STORAGE_NAME);
};
